export const storeSidebarToggled = sidebarToggled => ({
  type: 'STORE_SIDEBAR_TOGGLED',
  sidebarToggled
});

const initialState = {
  sidebarToggled: false
};

export default function contentReducer(state = initialState, action) {
  switch (action.type) {
    case 'STORE_SIDEBAR_TOGGLED': {
      return {
        ...state,
        sidebarToggled: action.sidebarToggled
      };
    }
    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ../core/src/store/layoutOptions.js